import { FC, Fragment } from 'react'

import { LinkifyBox } from '@/lib/reactLinkify'

import { SafeHtml } from './SafeHtml'
import { useSplitText } from './useSplitText'

type HtmlRendererProps = {
  text: string
  enableEmbedHtml: boolean
  tagName: keyof JSX.IntrinsicElements
}
/**
 *
 * @param {string} text 埋め込むテキスト文字列
 * @param {boolean} enableEmbedHtml falseの場合、HTML判定された箇所は表示しない
 */
export const HtmlRenderer: FC<HtmlRendererProps> = ({
  text,
  enableEmbedHtml,
  tagName,
}) => {
  const textBlocks = useSplitText(text, tagName)
  return (
    <>
      {textBlocks.map((block, index) => (
        <Fragment key={index}>
          {block.type === 'html' && (
            <SafeHtml enable={enableEmbedHtml} text={block.text} />
          )}
          {block.type === 'string' && <LinkifyBox>{block.text}</LinkifyBox>}
        </Fragment>
      ))}
    </>
  )
}
